import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentsFetchStatus = createSelector(
  [(store: RootState) => store.locationShow.documentsFetchStatus],
  (data) => data
);
